import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=0d8db34c&"
import script from "./copy.vue?vue&type=script&lang=js&"
export * from "./copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8db34c')) {
      api.createRecord('0d8db34c', component.options)
    } else {
      api.reload('0d8db34c', component.options)
    }
    module.hot.accept("./copy.vue?vue&type=template&id=0d8db34c&", function () {
      api.rerender('0d8db34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/copy.vue"
export default component.exports